<template>
  <div>
    <slot v-if="clearable" name="clearable"
      ><a @click="setRadioNull">X {{ $t("CLEAR") }}</a></slot
    >
    <v-radio-group
      v-bind:class="checkValidStateClass(validateState)"
      v-bind="$attrs"
      :value="value"
      @change="setSelected"
      :mandatory="false"
      :row="rowHorizontal"
    >
      <template v-for="(option, index) in options">
        <v-radio :value="option.id" v-bind:key="'radiogroup-' + name + index">
          <template v-slot:label>
            <div>
              {{ option.name }}
              <strong class="success--text" v-if="option.description"
                >({{ option.description }})</strong
              >
            </div>
          </template>
        </v-radio>
      </template>
    </v-radio-group>

    <b-form-invalid-feedback
      v-if="i18n.validation"
      :id="'invalid-' + feedback_id"
    >
      {{ $t(i18n.validation, validations.params) }}
    </b-form-invalid-feedback>
    <b-form-invalid-feedback v-else :id="'invalid-' + feedback_id">
      {{ $t("INVALID", { name: "" }) }}
    </b-form-invalid-feedback>
    <b-form-valid-feedback :id="'valid-' + feedback_id">
      {{ $t("VALID") }}
    </b-form-valid-feedback>
  </div>
</template>

<script>
export default {
  name: "FormRadio",
  inheritAttrs: false,
  props: {
    /**
     * Validation id of the error
     */
    feedback_id: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false
    },
    /**
     * All options existing in the radio group options
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * All Translation i18n keys used
     */
    i18n: {
      type: Object,
      default: function () {
        return {};
      }
    },
    /**
     * All validations rules and params
     */
    validations: {
      type: Object,
      default: function () {
        return {};
      }
    },
    /**
     * Validate State validation
     */
    validateState: {
      type: Boolean,
      default: null
    },
    /**
     * V-Model
     */
    value: {},
    /**
     * Vertical or Horizontal align of the radio buttons in the group
     */
    rowHorizontal: Boolean
  },
  data() {
    return {};
  },
  components: {},
  mounted() {},
  computed: {
    isChecked() {
      return !!this.value;
    }
  },
  methods: {
    checkValidStateClass(validateState) {
      if (validateState == true) {
        return "is-valid";
      }

      if (validateState == false) {
        return "is-invalid";
      }

      return "";
    },
    setRadioNull() {
      let vm = this;
      let value = null;
      vm.setSelected(value);
    },
    setSelected(value) {
      // alert(value);
      //  trigger a mutation, or dispatch an action
      this.$emit("input", value);
    }
  }
};
</script>
